import { Stage } from '../types/game';

export const initialStages: Stage[] = [
  {
    id: 'step-1-variables-datatypes',
    name: 'Step1: 変数とデータ型',
    description:
      '変数の宣言、代入、数値、文字列、ブーリアンなどの基本的なデータ型について学びます。',
    lines: [
      { code: 'let score = 0;' },
      { code: 'let playerName = "Hero";' },
      { code: 'let isActive = true;' },
    ],
    storyBefore: 'プログラミングの世界へようこそ！まずは基本中の基本、変数とデータ型から始めよう。',
    storyAfter: '変数とデータ型の基本をマスターした！これでプログラムに情報を記憶させられるぞ。',
    programmingConcept: '変数、データ型',
  },
  {
    id: 'step-2-operators',
    name: 'Step2: 演算子',
    description:
      '数値計算を行う算術演算子、値を比較する比較演算子、条件を組み合わせる論理演算子を学びます。',
    lines: [
      { code: 'let a = 10 + 5;' },
      { code: 'let isEqual = (a == 15);' },
      { code: 'let canProceed = isActive && (score > 0);' },
    ],
    storyBefore: '次は演算子だ。これを使えば、プログラムが計算や比較を行えるようになる。',
    storyAfter: '演算子の使い方が分かった！これでプログラムがより賢い判断をできるようになったぞ。',
    programmingConcept: '演算子',
  },
  {
    id: 'step-3-conditionals',
    name: 'Step3: 条件分岐 (if)',
    description: '特定の条件が満たされた場合にのみコードを実行する「if」文の使い方を学びます。',
    lines: [
      { code: 'if (score > 100) {' },
      { code: '  System.print("High score!");' },
      { code: '} else {' },
      { code: '  System.print("Keep trying!");' },
      { code: '}' },
    ],
    storyBefore: 'プログラムにも判断力が必要だ。条件分岐を学んで、状況に応じた動きをさせよう。',
    storyAfter: '条件分岐をマスター！プログラムが自分で考えて行動できるようになったぞ。',
    programmingConcept: '条件分岐、if文',
  },
  {
    id: 'step-4-loops',
    name: 'Step4: 繰り返し (for, while)',
    description: '同じ処理を何度も繰り返す「for」ループと「while」ループの使い方を学びます。',
    lines: [
      { code: 'for (let i = 0; i < 3; i++) {' },
      { code: '  Robot.action("special");' },
      { code: '}' },
      { code: 'while (Energy.level > 50) {' },
      { code: '  Robot.move();' },
      { code: '}' },
    ],
    storyBefore: '繰り返し処理はプログラミングの強力な武器だ。ループを使いこなそう！',
    storyAfter: 'ループ処理を覚えた！これで退屈な繰り返し作業もプログラムに任せられる！',
    programmingConcept: '繰り返し、forループ、whileループ',
  },
  {
    id: 'step-5-functions',
    name: 'Step5: 関数',
    description:
      '一連の処理をまとめて名前をつけ、再利用可能にする「関数」の作り方と使い方を学びます。',
    lines: [
      { code: 'function greet(name) {' },
      { code: '  return "Hello, " + name;' },
      { code: '}' },
      { code: 'let message = greet("AI");' },
    ],
    storyBefore:
      'プログラムが複雑になってきたかな？関数を使えば、コードを整理して分かりやすくできるぞ。',
    storyAfter: '関数を理解した！これで君も立派なプログラマーの仲間入りだ！',
    programmingConcept: '関数、引数、戻り値',
  },
  {
    id: 'step-6-error-handling',
    name: 'Step6: エラー対応 (try-catch)',
    description:
      'プログラム実行中に予期せぬエラーが発生した場合に備える「try-catch」構文を学びます。',
    lines: [
      { code: 'try {' },
      { code: '  RiskyOperation.execute();' },
      { code: '} catch (error) {' },
      { code: '  System.handleError(error);' },
      { code: '}' },
    ],
    storyBefore: 'エラーはつきもの。でも大丈夫、エラー対応を学べば、プログラムはもっと強くなる！',
    storyAfter: 'エラー対応の基本を習得！これで不測の事態にも対応できるようになったぞ。',
    programmingConcept: 'エラーハンドリング、try-catch',
  },
  {
    id: 'step-7-comprehensive-review',
    name: 'Step7: 今までの総合',
    description:
      'これまでに学んだ変数、演算子、条件分岐、繰り返し、関数を組み合わせた総合問題に挑戦します。',
    lines: [
      { code: 'function checkTaskStatus(taskId) {' },
      { code: '  let task = findTask(taskId);' },
      { code: '  if (task.status == "completed") {' },
      { code: '    Logger.info("Task " + taskId + " is done.");' },
      { code: '    return true;' },
      { code: '  } else if (task.status == "pending") {' },
      { code: '    for (let i = 0; i < task.retries; i++) {' },
      { code: '      if (task.attemptRetry()) break;' },
      { code: '    }' },
      { code: '  }' },
      { code: '  return false;' },
      { code: '}' },
    ],
    storyBefore: 'いよいよ最終ステップだ。今までの知識を総動員して、この課題をクリアしよう！',
    storyAfter: '素晴らしい！全てのステップをクリアしたね！',
    programmingConcept: '総合演習',
  },
];
